import * as paper from 'paper'
import { mapGetters } from 'vuex'
import * as animatePaper from "paper-animate"
export default {
    data(){
        return {
            raster:{
                obj: null,
                scale: 0,
                image: {
                    ratio: 0,
                    orgSize :{
                        width: 0,
                        height: 0
                    },
                    size: {
                        width: 0,
                        height: 0
                    }
                }
            }
        }
    },
    mounted(){
        this.$eventbus.$on('raster-visibility-changed', this.__raster_visiblity)
    },
    computed:{
        ...mapGetters({
            'project': 'projects/item',
            'sections': 'sections/items',
            'unitScale': 'projects/scale',
            'isScaleSet': 'projects/isScaleSet',
            'scale' : 'assets/scale',
        }),
        groups:{
            get(){
                return this.$store.getters['canvas/groups']
            },
            set(value){
                this.$store.commit('canvas/groups', value)
            }
        },
        symbols:{
            get(){
                return this.$store.getters['canvas/symbols']
            },
            set(value){
                this.$store.commit('canvas/symbols', value)
            }
        },
        controls: {
            get(){
                return this.$store.getters['canvas/controls']
            },
            set(val){
                this.$store.commit('canvas/controls', val)
            }
        },
        dots: {
            get(){
                return this.$store.getters['canvas/dots']
            },
            set(val){
                this.$store.commit('canvas/dots', val)
            }
        }
    },
    methods: {
        __raster_init(){
            this.raster.obj && this.raster.obj.remove()
            if(!this.image) return
            this.$eventbus.$emit('show-toast', 'Loading Image')
            this.raster.obj = new paper.Raster(this.image.signed_url);
            this.raster.obj.on('load', this.__raster_loaded);
            this.raster.obj.on('click', ()=>{
                this.__section_clear_dots()
                this.$store.dispatch('ui/projectSidebar.close')
            })
        },
        __raster_visiblity(visibility=true){
            this.raster.obj.visible = visibility
        },
        __raster_loaded(){
            // this.$eventbus.$emit('close-toast')
            let {height, width} = this.raster.obj.size
            this.raster.image.orgSize = { width, height }
            this.raster.image.size = { width, height}
            this.raster.image.ratio = height / width
            this.$store.dispatch('assets/setScale', 1)
            if(width > window.innerWidth){
                width = window.innerWidth;
                height = window.innerWidth * this.raster.image.ratio
                this.raster.obj.size = new paper.Size(width, height)
                this.raster.image.size = this.raster.obj.size
                this.raster.scale = this.raster.image.orgSize.width / this.raster.image.size.width
                this.$store.dispatch('assets/setScale', this.raster.scale)
            }
            this.raster.obj.position = new paper.Point(width/2, height/2)
            
            this.__sections_fetch()
        },
        __sections_fetch(){
            this.$eventbus.$emit('show-toast', 'Fetching Sections')
            this.$store.dispatch('sections/all', {projectId: this.project.id}).then((res)=>{
                this.$eventbus.$emit('show-toast', 'Drawing Sections')
                this.__sections_redraw()
            })
        },
        __sections_update(polygon){
            let section = polygon.data.section
            const {x,y} = polygon.bounds.center
            section.center_coords = {x, y}
            if(polygon.segments){
                section.coords = polygon.segments.map(segment=>{
                    return { x: segment.point.x * this.scale, y: segment.point.y * this.scale}
                });
            }else{
                section.coords = [{x:x*this.scale,y: y*this.scale}]
            }
            section = this.__sections_calculate_area(section)
            section = this.__sections_calculate_properties(section, false)
            section = this.__sections_find_parent_roof(section, false)
            this.$store.dispatch('sections/update', {
                projectId: section.project_id,
                id: section.id,
                payload: {
                    section: section
                },
                config: {
                    params: {
                        include: ['equipment_detail', 'equipment_detail.equipment_config']
                    }
                },
            })
        },
        __sections_redraw(){
            this.groups.forEach((l)=>l.obj && l.obj.remove())
            this.__section_clear_dots()
            this.groups = []
            
            this.sections.filter(s => s.section_type == 'roof').forEach(section => {
                this.__sections_draw(section)
            });
            this.sections.filter(s => s.section_type != 'roof').forEach(section => {
                this.__sections_draw(section)
            });
            
            if(!this.isScaleSet)  {
                this.$eventbus.$emit('show-toast', 'Kindly Set Unit Scale.',{
                    loader: false
                })
            }else{
                this.$eventbus.$emit('close-toast')
            }

            let id = this.$store.getters['canvas/dragEquipId']
            if(id && this.groups[id]){
                this.__section_clicked({
                    target: this.groups[id].obj.chidren[0]
                })
            }
            
        },
        __sections_draw(section){
            switch(section.shape_type){
                case 'marker': 
                    this.__section_draw_marker(section)
                    break
                default: 
                    this.__section_draw_polygon(section)
            }
        },
        __section_draw_marker(section){
            let group = new paper.Group();
            this.groups[section.id] = {
                obj: group,
                section: section
            }
            // const color = section && section.equipment_detail && section.equipment_detail.equipment_config && section.equipment_detail.equipment_config.color || 'red'
            // let shape = new paper.Path.Circle({
            //     fillColor: color,
            //     radius: 10,
            //     center: [section.coords[0].x/this.scale, section.coords[0].y/this.scale]
            // });

            let equip_id = section.equipment_detail.equipment_config_id

            let shape = this.symbols[equip_id].place();
            shape.position = new paper.Point(section.coords[0].x/this.scale, section.coords[0].y/this.scale)
            
            group.addChild(shape)
            shape.data = { section }
            group.data = {
                options: {
                    drag: section.id == this.$store.getters['canvas/dragEquipId']
                }
            }
            shape.onClick = this.__section_clicked
            group.onMouseDrag = this.__section_drag
            /** ==========================
             * Adding Label to Section
             * ===========================
             */
            let textObj = new paper.PointText({
                point: shape.bounds.center.add({x:0,y:20}),
                content: section.label || "No Label",
                fillColor: 'black',
                fontSize: 8,
                justification: 'center',
            });
            let rect = new Path.Rectangle(textObj.bounds, new paper.Size(3,3));
            rect.fillColor = 'cyan';
            rect.strokeColor = 'cyan';
            group.addChild(rect)
            textObj.insertAbove(rect);
            rect.scale(1.2)
            group.addChild(textObj)
            /**
             * END ===========================
             */
        },
        __section_draw_polygon(section){
            let group = new paper.Group();
            this.groups[section.id] = {
                obj: group,
                section: section
            }
            let shape = new paper.Path({
                strokeWidth: 2,
                strokeColor: section && section.equipment_detail && section.equipment_detail.equipment_config && section.equipment_detail.equipment_config.color || 'red',
                fullySelected:false,
                closed: section.shape_type == 'polygon',
                fillColor: new Color(1, 1,1, 0.01)
            });

            group.addChild(shape)
            shape.data = { section }
            group.data = {
                options: {
                    drag: section.id == this.$store.getters['canvas/dragEquipId']
                }
            }
            shape.onClick = this.__section_clicked
            group.onMouseDrag = this.__section_drag
            section.coords.forEach(point=>{
                shape.add(new paper.Point( point.x/this.scale, point.y/this.scale ))
            })
            let equip_id = 0
            if(section.equipment_detail){
                equip_id = section.equipment_detail.equipment_config_id
            }   
            
            let instance = this.symbols[equip_id].place();
            instance.position = shape.bounds.center
            instance.onClick = ()=>{
                this.__section_clicked({
                    target: shape
                })
            }
            group.addChild(instance)
            

            /** ==========================
             * Adding Label to Section
             * ===========================
             */
            if(section.label){
                let textObj = new paper.PointText({
                    point: shape.bounds.center,
                    content: section.label || "No Label",
                    fillColor: 'black',
                    fontSize: 8,
                    justification: 'center',
                });
                let rect = new Path.Rectangle(textObj.bounds, new paper.Size(3,3));
                rect.fillColor = 'cyan';
                rect.strokeColor = 'cyan';
                group.addChild(rect)
                textObj.insertAbove(rect);
                rect.scale(1.2)
                group.addChild(textObj)
            }
            /**
             * END ===========================
             */
            
        },

        __sections_draw_label(polygon, vector, from, config){
            let lengthSize = 2
            let sign = vector.angle < 0 ? -1 : 1
            let awayVector = null;
            let upVector = null;
            awayVector = vector.normalize(lengthSize).rotate(90 * sign);
            upVector = vector.normalize(lengthSize).rotate(45 * sign);
            let downVector = upVector.rotate(-90 * sign);
            let lengthVector = vector.normalize(
                    vector.length / 2 - lengthSize * Math.sqrt(2));
            let line = new paper.Path();
            line.add(from.add(awayVector));
            line.lineBy(upVector);
            line.lineBy(lengthVector);
            line.lineBy(upVector);
            let middle = line.lastSegment.point;
            line.lineBy(downVector);
            line.lineBy(lengthVector);
            line.lineBy(downVector);
            let textAngle = vector.angle;
            line.remove()
            
            if(Math.abs(vector.angle) > 90 ){
                textAngle += 180
            }

            let away = (sign >= 0 ? [1, 4] : [2, 3]).indexOf(vector.quadrant) != -1
                        ? 2 : 0;

            let value = vector.length;

            /** Calculating Length for Original Sized Image */
            value = value * this.scale * this.unitScale
            
            let point = middle.add(awayVector.normalize(away + lengthSize));
            if(polygon.contains(point)){
                lengthSize = -15
            }
            
            let textObj = new paper.PointText({
                point: middle.add(awayVector.normalize(away + lengthSize)),
                content: Math.floor(value * 100) / 100 + ` ` + (this.unit.abbr || ''),
                fillColor: 'white',
                fontSize: 5,
                justification: 'center',
            });
            console.log("label --- ", textObj, textAngle)
            // console.log("width:length -- ",textObj.bounds.width, vector.length/2)
            if(textObj.bounds.width >= vector.length/2){
                config.labelScaleDown = true
            }
            var rect = new Path.Rectangle(textObj.bounds, new paper.Size(2,2)); // Second Param is border-radius
            rect.fillColor = 'black'
            rect.strokeColor = 'black'
            textObj.insertAbove(rect)
            rect.rotate(textAngle)
            rect.scale(1.2)
            textObj.rotate(textAngle)
            
            let data = {
                type: "label"
            }
            textObj.data = data
            rect.data = data
            this.dots.push(rect)
            this.dots.push(textObj)
        },

        __section_clear_dots(){
            this.dots.forEach(i=>i.remove())
        },

        __section_clicked(event){
            let obj = event.target
            let section = obj.data.section
            this.$store.dispatch('sections/selectItem', section.id)
            let config = {
                labelScaleDown: false
            }

            this.$store.dispatch('ui/projectSidebar.open', {
                component: 'SectionInfoDrawer',
                heading: `${section.section_type} Details`,
                width: '300px',
                right: true,
                noHeader: true,
                key: `section-${section.id}`
            })

            /* 
             * ===================================
             * Draw segment bullets
             * ===================================
             */

            /* Skip segment bullets if type is marker */
            if(section.shape_type == 'marker'){
                return
            }
            
            /* Remove existing dots */
            this.__section_clear_dots()
            
            let segments = obj.segments;
            for(let i=0;i < segments.length;i++){
                
                let start = i;
                let end = i+1;
                if(end == segments.length){
                    if(section.shape_type == 'polyline') continue
                    end = 0;
                }
                let vector = segments[end].point.subtract(segments[start].point)
                this.__sections_draw_label(obj, vector, segments[start].point, config)


                //dots
                let segment = segments[i]
                let dot = new paper.Path.Circle({
                    center: [segment.point.x, segment.point.y],
                    radius: 5,
                    strokeColor: obj.strokeColor,
                    fillColor: "white"
                })
                this.dots.push(dot)
                dot.data = { type:"segment", segment: segment }

                dot.onMouseDown = (event)=>{
                    if(!event.modifiers.shift){
                        this.canvas.segment = dot
                    }
                }
                dot.onClick = (event) => {
                    if(event.modifiers.shift){
                        dot.remove()
                        segment.remove()
                        this.__sections_update(obj)
                    }
                }
                dot.onMouseEnter = (event)=>{
                    document.getElementById("paper-js").style.cursor = "pointer";
                }
                dot.onMouseLeave = (event)=>{
                    document.getElementById("paper-js").style.cursor = "default";
                }
                dot.onMouseMove = (event)=>{
                    let obj = event.target
                    obj.fillColor = event.modifiers.shift ? "red" : "white"
                }

            }

            for(let i=0;i < segments.length;i++){
                let start = i
                let end = i+1
                if(end >= segments.length) end = 0 
                
                let line = new paper.Path.Line({from:segments[start].point, to: segments[end].point})
                let point = line.bounds.center;
                line.remove()

                let dot = new paper.Path.Circle({
                    center: point,
                    radius: 5,
                    opacity: 0.5,
                    fillColor: "grey"
                })

                this.dots.push(dot)
                dot.data = { type:"new-point", segment: null }

                dot.onMouseEnter = (event)=>{
                    document.getElementById("paper-js").style.cursor = "pointer";
                }
                dot.onMouseLeave = (event)=>{
                    document.getElementById("paper-js").style.cursor = "default";
                }

                dot.onMouseDown = (event)=>{
                    if(!event.modifiers.shift){
                        console.log("new point:: ",event.point)
                        obj.insert(i+1, event.point)
                        dot.data.segment = obj.segments[i+1]
                        console.log("segments:: ", obj.segments)
                        this.canvas.segment = dot
                    }
                }
            }



            if(config.labelScaleDown){
                this.dots.filter(e=>e.data.type && e.data.type == 'label').forEach((label)=>{
                    label.scale(0.5)
                })
            }
        },
        __section_drag(event){
            let obj = event.target
            if(obj.data?.options?.drag){
                this.controls.drag = false
                this.canvas.polygon = obj.children[0]
                this.__section_clear_dots()
                obj.position.x += event.delta.x
                obj.position.y += event.delta.y
            }

        },
        __section_locate(id){
            let obj = this.groups[id].obj
            animatePaper.fx.shake(obj);
            
            paper.view.zoom = 1 
            paper.view.center = obj.bounds.center
        },
        __sections_init_equipment_symbol(){
            let equipments = this.$store.getters["equipments/items"]
            this.symbols = []
            equipments.forEach(equip => {
                let img = new paper.Raster(require(`@/assets/equipment_icons/${equip.icon}`));
                img.scale(0.5)
                let symbolDef = new paper.SymbolDefinition(img)
                this.symbols[equip.id] = symbolDef
            });
            let img = new paper.Raster(require(`@/assets/hexagon-red.png`));
            img.scale(0.5)
            let symbolDef = new paper.SymbolDefinition(img)
            this.symbols[0] = symbolDef
        }
    }
}